import React from 'react';
import {
  MunicipalityIcon,
  MobileContainer,
  MobileMunicipalityContainer,
  MunicipalityName,
  MunicipalityAddress,
  MunicipalityValues,
  MunicipalityStatus,
  StatusDropdown,
  StatusOption,
  NoMunicipalities,
  MuniciPalityHeader,
  Header,
  AddMunicipalityContainer,
  MobileCreate,
  MunicipalityContainer,
} from './muncipalities-list-components';
import { useLocation } from '@app/utils';
import { Icon } from '@app/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

type Props = {
  statusFilterTypes: any;
  municipalityList: any;
  active: string;
  setActive: (e: any) => void;
  onFilterChange: (type: string) => void;
};

const IconStyle = {
  width: 20,
  height: 20,
};

export default function MobileMunicipalityList({
  statusFilterTypes,
  municipalityList,
  active,
  setActive,
  onFilterChange,
}: Props) {
  const { navigate } = useLocation();
  const [openFilter, setOpenFilter] = React.useState(false);
  const filterRef: any = React.useRef(null);
  const showMuniciplaityDetails = (data: any) => {
    const muncipalityId = data.id;
    navigate('/municipalities/details/' + muncipalityId);
  };

  const onStatusChange = (type: string) => {
    setActive(type);
    onFilterChange(type);
    setOpenFilter(false);
  };

  function handleClickOutside(e: any) {
    if (
      openFilter &&
      filterRef.current &&
      !filterRef.current.contains(e.target)
    ) {
      console.log(openFilter);
      setOpenFilter(false);
    }
  }

  document.addEventListener('click', handleClickOutside);
  return (
    <>
      {openFilter ? (
        <StatusDropdown>
          {statusFilterTypes.map((status: string) => {
            return (
              <StatusOption onClick={() => onStatusChange(status)}>
                {status}
              </StatusOption>
            );
          })}
        </StatusDropdown>
      ) : null}
      <MobileContainer>
        <Header>
          <MuniciPalityHeader>
            Municipalities ({municipalityList.length})
          </MuniciPalityHeader>
          <MunicipalityStatus onClick={() => setOpenFilter(true)}>
            showing
            <strong style={{ marginLeft: '8px' }} ref={filterRef}>
              {active}
            </strong>
            <Icon name="arrowDown" />
          </MunicipalityStatus>
        </Header>
        <MunicipalityContainer>
          {municipalityList && municipalityList.length ? (
            municipalityList.map((municipality: any) => {
              return (
                <MobileMunicipalityContainer
                  onClick={() => showMuniciplaityDetails(municipality)}>
                  <MunicipalityIcon image={municipality.logo} />
                  <div>
                    <MunicipalityName>{municipality.name}</MunicipalityName>
                    <MunicipalityAddress>
                      {municipality.address}
                    </MunicipalityAddress>
                    <MunicipalityValues>
                      {municipality.email}
                    </MunicipalityValues>
                    <MunicipalityValues>
                      {municipality.phoneNumber}
                    </MunicipalityValues>
                  </div>
                </MobileMunicipalityContainer>
              );
            })
          ) : (
            <NoMunicipalities>Municipalities not found</NoMunicipalities>
          )}
        </MunicipalityContainer>
      </MobileContainer>
      <AddMunicipalityContainer>
        <MobileCreate onClick={() => navigate('/municipalities/create')}>
          <FontAwesomeIcon color="#fff" icon={faPlus} style={IconStyle} />
        </MobileCreate>
      </AddMunicipalityContainer>
    </>
  );
}
